<ng-template #templateRef>
  <div class="p-inputgroup">
    <input type="text"
           pInputText
           [(ngModel)]="filterValue"
           [placeholder]="placeholder"
           (keyup.enter)="filter()" />
    @if (isFilterApplied) {
      <button pButton
              type="button"
              icon="pi pi-times"
              (click)="cleanFilter()"></button>
    }
  </div>
</ng-template>